import UploadImageModal from "./UploadImageModal"

export default  UploadImageModal;
